import React from 'react';
import PropTypes from 'prop-types';
import { compose, withState, withHandlers } from 'recompose';
import ProgressIndicator from 'components/ProgressIndicator';
import { Container, Row, Col } from 'reactstrap';
import { isInIframe } from 'hoc/withIframeHeightUpdate';

import { form as formName } from './components/configs/generator-needs-form-config';
import config from './configs/steps-config';
import AboutHome from './components/AboutHome';
import YourNeeds from './components/YourNeeds';
import Recommendations from './components/Recommendations';

const Form = ({ page, nextStep, previousStep, setStep }) => (
  <Container fluid className="app-wrapper">
    <Row>
      <Col xs={12}>
        <ProgressIndicator
          steps={config.steps}
          currentStep={page}
          handleClick={setStep}
          formName={formName}
        />
        {page === 1 && <AboutHome onSubmit={nextStep} /> }
        {page === 2 && <YourNeeds onSubmit={nextStep} previousStep={previousStep} /> }
        {page === 3 && <Recommendations previousStep={previousStep} /> }
      </Col>
    </Row>
  </Container>
);

Form.propTypes = {
  page: PropTypes.number.isRequired,
  nextStep: PropTypes.func.isRequired,
  previousStep: PropTypes.func.isRequired,
  setStep: PropTypes.func.isRequired,
};

const enhance = compose(
  withState('page', 'setPage', 1),
  withHandlers(() => {
    const scrollUp = isInIframe()
      ? () => window.parent.postMessage({ type: 'scrollToTop' }, '*')
      // eslint-disable-next-line no-multi-assign
      : () => { document.body.scrollTop = document.documentElement.scrollTop = 0; };
    return {
      nextStep: ({ setPage }) => () => setPage(page => page + 1) || scrollUp(),
      previousStep: ({ setPage }) => () => setPage(page => page - 1) || scrollUp(),
      setStep: ({ setPage }) => step => () => setPage(step) || scrollUp(),
    };
  }),
);

export default enhance(Form);



// WEBPACK FOOTER //
// ./src/views/Home/index.js